module.exports = __webpack_public_path__ + "img/geofisica_9-16_810.c4466cf3.jpg";